import { Injectable, Injector } from '@angular/core';
import { EduContentBookQueries, MethodInterface, MethodQueries, UnlockedFreePracticeQueries } from '@campus/dal';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BooksTileComponentInterface } from '../../components';
import { BooksTileService, BooksTileServiceConfigInterface } from './books-tile.service';
@Injectable()
export class KabasBooksTileService extends BooksTileService {
  constructor(protected injector: Injector) {
    super(injector);
    this.store = this.injector.get(Store);
  }

  public getBookTiles$(
    sourceFilter?: (data: MethodInterface) => boolean,
    config: BooksTileServiceConfigInterface<MethodInterface> = {}
  ): Observable<BooksTileComponentInterface[]> {
    return combineLatest([
      this.store.select(MethodQueries.getAllowedMethods),
      this.store.select(EduContentBookQueries.getByMethodId),
      config.filterUnlockedBooks ? this.store.select(UnlockedFreePracticeQueries.getGroupedByEduContentBookId) : of({}),
    ]).pipe(
      map(([allowedMethods, booksByMethodId, ufpByBookIdDict]) => {
        const filteredAllowedMethods = sourceFilter ? allowedMethods.filter(sourceFilter) : allowedMethods;

        let booksTiles = filteredAllowedMethods.map((method) => {
          let books = booksByMethodId[method.id] || [];

          if (config.filterUnlockedBooks) {
            books = books.filter((book) => !!ufpByBookIdDict[book.id]);
          }

          if (config.rowFilter) {
            books = books.filter((book) => config.rowFilter(book, method));
          }

          const tileTitle = config.titleFn ? config.titleFn(method) : method.name;

          const hasActions = config.actionHandler && config.allowedActions?.length > 0;
          let tile = hasActions
            ? this.mapToBooksTileWithActions(
                method.id,
                tileTitle,
                method,
                books,
                config.actionHandler,
                config.allowedActions,
                config.favoriteBooks,
                null
              )
            : this.mapToBooksTileWithoutActions(method.id, tileTitle, method, books, null);

          if (config.rowSortComparer) {
            tile.rows.sort(config.rowSortComparer);
          }

          if (config.tileMapFn) {
            tile = config.tileMapFn(tile, method, books);
          }

          return tile;
        });

        if (config.filterEmptyTiles) {
          booksTiles = booksTiles.filter((tile) => !!tile.rows.length);
        }

        if (config.tileFilter) {
          booksTiles = booksTiles.filter(config.tileFilter);
        }

        if (config.tileSortComparer) {
          booksTiles.sort(config.tileSortComparer);
        }

        return booksTiles;
      })
    );
  }
}
